import { Checkbox, TableCell, TableHead, TableRow, Typography } from "@mui/material";

export type HeadCell = {
  id: string;
  label: string;
};

type SelectTableHeadProps = {
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  headCells: HeadCell[];
  checked: boolean;
  indeterminate: boolean;
};

const commonTableCellStyles = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: 500,
  fontSize: 11,
  letterSpacing: "0.01071em",
  display: "table-cell",
  verticalAlign: "inherit",
  borderBottom: "1px solid rgba(224, 224, 224, 1)",
  textAlign: "left",
  padding: "16px",
  paddingTop: "20px",
  paddingBottom: "20px",
  color: "rgba(0, 0, 0, 0.87)",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  maxWidth: "110px",
  borderLeft: "1px solid rgb(224, 224, 224)",
  borderTop: "1px solid rgb(224, 224, 224)",
};

const headerStyles = {
  ...commonTableCellStyles,
  position: "sticky",
  top: 0,
  zIndex: 1,
  fontSize: 16,
  fontWeight: 'bold',
  textAlign: "center",
  backgroundColor: "#fbefb4",
};

/**
 * SelectTableHead
 * @param root0 コンポーネントのprops
 * @returns JSX.Element
 */
function SelectTableHead({
  onSelectAllClick,
  headCells,
  checked,
  indeterminate,
}: SelectTableHeadProps) {
  return (
    <TableHead>
      <TableRow>
        <TableCell sx={headerStyles}>
          <Typography textAlign="center" fontSize={16} fontWeight="bold">削除</Typography>
          <Checkbox
            color="secondary"
            indeterminate={indeterminate}
            checked={checked}
            onChange={onSelectAllClick}
          />
          <Typography textAlign="center" fontSize={16} fontWeight="bold">全選択</Typography>
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell key={headCell.id} sx={headerStyles}>
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default SelectTableHead;
